// @file visioTemplatesCarousel.js

require('slick-carousel');

$('.js_visio-templates').slick({
  slidesToShow: 4,
  slidesToScroll: 4,
  mobileFirst: true,
  infinite: true,
  responsive: [
    {
      breakpoint: 1024,
      dots: false,
      arrows: true,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 768,
      dots: false,
      arrows: true,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 0,
      settings: {
        mobileFirst: false,
        dots: true,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
